import React, { memo } from "react";
import { useDispatch, useSelector } from "react-redux";

import { Button, Image, TopBarOptions } from "../Components";
import Icon from "../assets/icons/Icon";
import { Link } from "react-router-dom";

const Topbar = () => {
  const dispatch = useDispatch();
  const { user } = useSelector((state) => state.user);

  const handleSideCollapsed = () => {
    const body = document.querySelector("body");
    const currentSize = body.getAttribute("data-sidebar-size");
    if (currentSize && currentSize !== "default") {
      body.setAttribute("data-sidebar-size", "default");
    } else {
      body.setAttribute("data-sidebar-size", "collapsed");
    }
  };

  return (
    <header className="app-header">
      <nav className="nav_header">
        <div className="icon_menu">
          <Button
            className="sidebar-menu-icon men_menu_icon"
            icon="Menu"
            onClick={handleSideCollapsed}
          />
          <div className=" logo_img">
            <Link to="/live-market">
              <Image
                className="logo_icon"
                src="/assets/images/logo.svg"
                alt="logo icon"
              />
            </Link>
          </div>
        </div>

        <div className="login_box">
          {/* <div className="notification_box mobile_sett ">
            <Icon name="Bell" className="icon_new" />
          </div> */}

          {/* <div className="notification_box mobile_sett user-id">
            <Icon name="Search" />
            <div className="profile-hover-main search_card">
              <Icon name="Search" className="search_icon" />
              <Input
                placeholder="search..."
                type=" text"
                className="searchbar_box"
              />
            </div>
          </div> */}
          <TopBarOptions user={user} />
        </div>
      </nav>

      <div className="new_box">
        <span className="icon_new">
          <Icon name="Volume2" size={15} />
        </span>

        <marquee>Gold & Silver Duty updated to 6% and it's live now.</marquee>
      </div>
    </header>
  );
};

export default memo(Topbar);
